import { Warn } from './logging';

export function parseUrl(url: string, baseUrl = window.location.href) {
  if (!url) return null;

  try {
    if (url.startsWith('//')) {
      url = `${location.protocol}${url}`;
    }

    if (!url.startsWith('http')) {
      if (!url.startsWith('/')) {
        url = `${location.pathname}/${url}`;
      }

      return new URL(url, baseUrl).href;
    }

    return new URL(url).href;
  } catch (e) {
    Warn(e, url);
    return null;
  }
}

export function getUrlParameters(url = window.location.href) {
  const searchParams = new URL(url).searchParams;
  const result = {};
  for (const key of searchParams.keys()) {
    const value = searchParams.getAll(key);
    result[key] = value.length === 1 ? value[0] : value;
  }
  return result;
}

export function getParametersByName(name: string, url = window.location.href) {
  if (!name) return null;
  const searchParams = new URL(url).searchParams;

  for (const key of searchParams.keys()) {
    if (key.toLowerCase() === name.toLowerCase()) return searchParams.getAll(key);
  }

  return null;
}

export function getParameterByName(name: string, url = window.location.href) {
  const result = getParametersByName(name, url);
  return result ? result[0] : null;
}

export function setParametersInParameter(search: Record<string, any>, qs = '') {
  const Param = new URLSearchParams(qs);
  for (const key in search) {
    const value = search[key];
    if ((value ?? '') === '' || (Array.isArray(value) && !value.length)) {
      Param.delete(key);
    } else {
      Param.set(key, `${value}`);
    }
  }
  return Param;
}

export function setParametersInUrl(search: Record<string, any>, url = window.location.href) {
  url = parseUrl(url);
  if (!url) return null;

  const Url = new URL(url);
  for (const key in search) {
    const value = search[key];
    if ((value ?? '') === '' || (Array.isArray(value) && !value.length)) {
      Url.searchParams.delete(key);
    } else {
      Url.searchParams.set(key, `${value}`);
    }
  }
  return Url;
}

export function setUrlParameters(search: Record<string, any>, refresh?: boolean) {
  const searchParams = setParametersInUrl(search, window.location.href).searchParams;

  let qs = searchParams.toString();

  if (qs.length) qs = `?${qs}`;

  if (refresh) {
    document.location.search = qs;
  } else if (window.history.pushState) {
    const newurl = window.location.pathname + qs + window.location.hash;
    window.history.pushState({ path: newurl }, '', newurl);
  }
}

/**
 * Checks if the referrer of the current document comes from a specific domain.
 * @param domain The domain to check for. Can be either a fully qualified domain name (e.g. "example.com") or a partial domain (e.g. ".example.com").
 * @returns Whether the referrer of the current document comes from the specified domain.
 */
export function isReferrerFromDomain(domain: string): boolean {
  if (!domain || !document.referrer) return false;

  const referrerHostname = new URL(document.referrer).hostname.toLowerCase();
  return referrerHostname.endsWith(domain.toLowerCase());
}
